import { firebaseConfig } from './config';

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    const params = new URLSearchParams(firebaseConfig).toString();
    const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js?${params}`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // We need to send the configuration to the service worker.
        // We do this once the service worker is active.

        const sendConfig = () => {
          const sw = registration.active || registration.installing || registration.waiting;
          if (sw) {
            sw.postMessage({
              type: 'SET_CONFIG',
              config: firebaseConfig,
            });
          }
        };

        if (registration.active) {
          sendConfig();
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              sendConfig();
            }
          });
        });
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });

    // Also send config when the controller changes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'SET_CONFIG',
          config: firebaseConfig,
        });
      }
    });
  } else {
    // Service Worker not supported — FCM push notifications will not work
  }
}
